"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Thumbnails;

var _react = _interopRequireWildcard(require("react"));

var _useClassBuilder = _interopRequireDefault(require("../../hooks/useClassBuilder"));

var _useStyleBuilder = _interopRequireDefault(require("../../hooks/useStyleBuilder"));

var _useRandomId = _interopRequireDefault(require("../../hooks/useRandomId"));

var _ = require("../");

var _thumbnail = _interopRequireDefault(require("./thumbnail.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*---------------------------------------------*/
var BASE_CLASS = 'lth-c-thumbnails';
/*---------------------------------------------*/

function Thumbnails(props) {
  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      uncontrolledValue = _useState2[0],
      setUncontrolledValue = _useState2[1];

  var componentId = (0, _useRandomId.default)();

  function onThumbnailSelected(value) {
    setUncontrolledValue(value);
    props.onChange && props.onChange(value);
  }

  var classes = (0, _useClassBuilder.default)(props, BASE_CLASS);
  var style = (0, _useStyleBuilder.default)(props);
  var value = props.value || uncontrolledValue;

  var label = props.label && /*#__PURE__*/_react.default.createElement(_.Label, {
    disabled: props.disabled
  }, props.label);

  var thumbnails = _react.default.Children.map(props.children, function (child, index) {
    var props = {
      onSelected: onThumbnailSelected,
      selected: value === child.props.value,
      key: index,
      inputName: componentId
    };
    return /*#__PURE__*/_react.default.cloneElement(child, props);
  });

  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes,
    style: style
  }, label, /*#__PURE__*/_react.default.createElement("div", {
    className: BASE_CLASS + '__container'
  }, thumbnails));
}
/*---------------------------------------------*/


Thumbnails.Item = _thumbnail.default;
Thumbnails.METADATA = {
  name: 'Thumbnails',
  props: [{
    name: 'label',
    type: 'string',
    default: 'Choose one item'
  }, {
    name: 'value',
    type: 'string',
    default: undefined
  }, {
    name: 'onChange',
    type: 'function',
    description: 'Callback function called when the value was changed'
  }],
  content: {
    default: [/*#__PURE__*/_react.default.createElement(Thumbnails.Item, {
      badge: "Premium",
      label: "Option 1",
      value: "value1",
      img: "https://inffuse-fbpopup.appspot.com/img/templates/t1.svg",
      imgSelected: "https://inffuse-fbpopup.appspot.com/img/templates/t1hover.svg",
      key: "value1"
    }), /*#__PURE__*/_react.default.createElement(Thumbnails.Item, {
      label: "Option 2",
      value: "value2",
      img: "https://inffuse-fbpopup.appspot.com/img/templates/t2.svg",
      imgSelected: "https://inffuse-fbpopup.appspot.com/img/templates/t2hover.svg",
      key: "value2"
    }), /*#__PURE__*/_react.default.createElement(Thumbnails.Item, {
      label: "Option 3",
      value: "value3",
      img: "https://inffuse-fbpopup.appspot.com/img/templates/t3.svg",
      imgSelected: "https://inffuse-fbpopup.appspot.com/img/templates/t3hover.svg",
      key: "value3"
    }), /*#__PURE__*/_react.default.createElement(Thumbnails.Item, {
      label: "Option 1",
      value: "value21",
      badge: "Premium",
      img: "https://inffuse-fbpopup.appspot.com/img/templates/t1.svg",
      imgSelected: "https://inffuse-fbpopup.appspot.com/img/templates/t1hover.svg",
      key: "value1"
    }), /*#__PURE__*/_react.default.createElement(Thumbnails.Item, {
      label: "Option 2",
      value: "value22",
      img: "https://inffuse-fbpopup.appspot.com/img/templates/t2.svg",
      imgSelected: "https://inffuse-fbpopup.appspot.com/img/templates/t2hover.svg",
      key: "value2"
    }), /*#__PURE__*/_react.default.createElement(Thumbnails.Item, {
      label: "Option 3",
      value: "value23",
      img: "https://inffuse-fbpopup.appspot.com/img/templates/t3.svg",
      imgSelected: "https://inffuse-fbpopup.appspot.com/img/templates/t3hover.svg",
      key: "value3"
    })]
  }
};